/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Partner_Org_Kpi_Used_Ai_Badge_BillInputs */



/**
* | output |
* | --- |
* | "of {total} members today, in this bill's period" |
*
* @param {Partner_Org_Kpi_Used_Ai_Badge_BillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_used_ai_badge_bill = /** @type {((inputs: Partner_Org_Kpi_Used_Ai_Badge_BillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Used_Ai_Badge_BillInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von ${i?.total} heutigen Mitgliedern, im Zeitraum dieser Rechnung`)
	return /** @type {LocalizedString} */ (`of ${i?.total} members today, in this bill's period`)
});